import React, { useState } from "react";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
// import CloseIcon from "@mui/icons-material/Close";
import CachedIcon from "@mui/icons-material/Cached";
import { CheckCircle } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";

import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css"
import { Button } from "../../myfin_v2/elements/Button"
import { ReactComponent as UploadIcon } from "../../myfin_v2/assets/icons/upload.svg"
import wsCreationcss from "../../myfin_v2/css/workspaceCreation.module.css";
import { ReactComponent as ImgIcon } from "../../myfin_v2/assets/icons/img.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";


function ImageUpload({ uploadImages, headerNumber }) {
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  // Handle image selection
  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
    setImageName(selectedImage ? truncateFileName(selectedImage.name) : "");
  };

  function truncateFileName(name, maxLength = 12) {
    if (name.length <= maxLength) {
      return name;
    }
    return name.slice(0, 9) + "...";
  }

  const removeImage = () => {
    setImage(null);
    setImageName("");
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!image) {
      alert("Please select an image.");
      return;
    }
    setUploading(true); // Start showing progress icon
    const formData = new FormData();
    formData.append("image", image);

    // Replace 'your-api-endpoint' with your actual API endpoint
    const url = process.env.REACT_APP_PYTHON_URL + "upload_image";
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        setUploadSuccess(true); // Show success icon
        uploadImages(data.image_url, headerNumber);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setUploading(false); // Hide progress icon
      });
  };

  return (
    <>
      {imageName ? (
        <>

          <button
            className={wsCreationcss.perviewBtn}
            type="button"
            style={{ padding: "5px 7px" }}
          >
            <ImgIcon height={19} />
            {imageName}{" "}

            {uploading && (
              <CachedIcon size={24} style={{ animation: 'rotate 2s linear infinite' }} />
            )}
            {uploadSuccess && <CheckCircle color="success" />}
            {!uploading && !uploadSuccess ?
              <>
                <DoneIcon color="success" style={{ width: "15px", height: "15px", cursor: "pointer" }} onClick={handleSubmit} />

                <CloseIcon
                  height={15}
                  onClick={removeImage}
                />
              </>
              : ""
            }
          </button>
        </>

      ) : (
        <div
          className="mt-3 d-flex align-items-center justify-content-center w-100 "
          style={{
            height: "90px",
            backgroundColor: "#F4FAF5",
            border: "1px dashed #A0DABC",
            borderRadius: "10px",
          }}
        >


          <input
            id="imageInput"
            type="file"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
          <div className='d-flex flex-column align-items-center' onClick={() => document.getElementById("imageInput").click()}>
            <div className='d-flex justify-content-center align-items-center' style={{ height: '100px', "flex-direction": "column", "gap": "10px" }}>
              <div className={commoncss.greyLabel}>Drag and drop your image here or click on upload</div>
              <div>
                <Button
                  btnColor={buttoncss.secondary}
                  class_={commoncss.lightBg}
                  label="Upload"
                  icon={<UploadIcon width={15} />}
                  onClick={() => document.getElementById("imageInput").click()}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ImageUpload;
